






































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import { AppModule } from '@/store/modules/app';
import { getSetting, putMogiriSetting } from '@/api/users';
import {
  MogiriSettingSupplier,
  MogiriSettingSupplierColor,
  MogiriSettingSupplierIssuedTicketBackgroundColors,
} from '@/api/types';
import { formatApiError } from '@/utils/index';
import { translateRouteTitle } from '@/utils/permission';

type Color = {
  key: string;
  enable: boolean;
  hex?: string;
  preset?: string;
};

type ItemType = {
  text: string;
  value: string;
};

@Component({
  name: 'SettingSupplier',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  private mogiriSetting: MogiriSettingSupplier = {};
  private loading = true;
  private valid = false;
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;
  private dialogTextTitle = '';
  private dialogTextFooter = '';
  private colorItems: ItemType[] = [];
  private enableWeeksBgcolor: Color[] = [];
  private enableExpiredBgColors: Color = {
    key: 'expired',
    enable: false,
    hex: '',
    preset: '',
  };
  private enableColorPrimaryHex = {
    enable: false,
    hex: '',
  };
  private defaultLogoWidth = 320;

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  get canUpdatePassword() {
    return this.valid;
  }

  private hexa2hex(hexa: string) {
    return hexa.length > 7 ? hexa.substr(0, 7) : hexa;
  }

  mounted() {
    this.fetchData();
    this.loadColor();
    this.loading = false;
  }

  private loadColor() {
    this.colorItems = [
      {
        text: 'NULL',
        value: '',
      },
      {
        text: 'WHITE',
        value: 'WHITE',
      },
      {
        text: 'BLACK',
        value: 'BLACK',
      },
      {
        text: 'BLUE',
        value: 'BLUE',
      },
      {
        text: 'CYAN',
        value: 'CYAN',
      },
      {
        text: 'GREEN',
        value: 'GREEN',
      },
      {
        text: 'PURPLE',
        value: 'PURPLE',
      },
      {
        text: 'RED',
        value: 'RED',
      },
      {
        text: 'YELLOW',
        value: 'YELLOW',
      },
    ];
  }

  private async fetchData(noLoading = false) {
    if (!noLoading) {
      this.loading = true;
      AppModule.StartProgress();
    }
    this.enableWeeksBgcolor = this.getDefaultWeeksBgColor();
    await this.fetchSettings();

    if (!noLoading) {
      this.loading = false;
      AppModule.StopProgress();
    }
  }

  private async fetchSettings() {
    const res = await getSetting();
    if (res.mogiriSetting) {
      this.mogiriSetting = res.mogiriSetting;
      if (!!res.mogiriSetting.colorPrimaryHex) {
        this.enableColorPrimaryHex.enable = true;
        this.enableColorPrimaryHex.hex = this.hexa2hex(
          res.mogiriSetting.colorPrimaryHex
        );
      }
      if (!this.mogiriSetting.logoWidth) {
        this.mogiriSetting.logoWidth = this.defaultLogoWidth;
      }
      this.loadBgColors();
    } else {
      this.mogiriSetting = this.getDefaultMogiriSetting();
    }
  }

  private getDefaultMogiriSetting() {
    return {
      issueUndoDurationSeconds: 5,
      issuedTicketBackgroundColors: ({
        sun: null,
        mon: null,
        tue: null,
        wed: null,
        thu: null,
        fri: null,
        sat: null,
        expired: null,
      } as unknown) as MogiriSettingSupplierIssuedTicketBackgroundColors,
      colorPrimaryHex: '',
      logoUrl: '',
      logoWidth: this.defaultLogoWidth,
    };
  }

  private loadBgColors() {
    const colors = this.mogiriSetting.issuedTicketBackgroundColors as Record<
      string,
      MogiriSettingSupplierColor
    >;
    ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].forEach(key => {
      if (colors[key]) {
        const index = this.enableWeeksBgcolor.findIndex(
          color => color.key === key
        );
        if (colors[key].hex) {
          this.enableWeeksBgcolor[index].enable = true;
          this.enableWeeksBgcolor[index].hex = colors[key].hex;
        }

        if (colors[key].preset) {
          this.enableWeeksBgcolor[index].preset = colors[key].preset;
        }
      }
    });
    if (colors['expired']?.hex) {
      this.enableExpiredBgColors.enable = true;
      this.enableExpiredBgColors.hex = colors['expired'].hex || '';
    }
    if (colors['expired']?.preset) {
      this.enableExpiredBgColors.preset = colors['expired'].preset;
    }
  }
  private getDefaultWeeksBgColor() {
    return [
      {
        key: 'sun',
        enable: false,
        hex: '',
        preset: '',
      },
      {
        key: 'mon',
        enable: false,
        hex: '',
        preset: '',
      },
      {
        key: 'tue',
        enable: false,
        hex: '',
        preset: '',
      },
      {
        key: 'wed',
        enable: false,
        hex: '',
        preset: '',
      },
      {
        key: 'thu',
        enable: false,
        hex: '',
        preset: '',
      },
      {
        key: 'fri',
        enable: false,
        hex: '',
        preset: '',
      },
      {
        key: 'sat',
        enable: false,
        hex: '',
        preset: '',
      },
    ];
  }

  private resetDialog() {
    this.dialog = false;
    this.dialogTextTitle = '';
    this.dialogTextFooter = '';

    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForUpdatePassword() {
    this.dialogTextTitle = `${this.translateRouteTitle(
      this.$route.meta.title
    )}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.updateMogiriSetting();
    };
    this.dialog = true;
  }

  private showDialogForReset() {
    this.dialogTextTitle = `${this.$t('Reset')}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.reset();
    };
    this.dialog = true;
  }

  private reset() {
    this.mogiriSetting.issueUndoDurationSeconds = 5;
    this.enableColorPrimaryHex = {
      enable: false,
      hex: '',
    };
    this.mogiriSetting.colorPrimaryHex = '';
    this.mogiriSetting.logoUrl = '';
    this.mogiriSetting.logoWidth = this.defaultLogoWidth;
    this.enableWeeksBgcolor = this.getDefaultWeeksBgColor();
    this.enableExpiredBgColors = {
      key: 'expired',
      enable: false,
      hex: '',
      preset: '',
    };
  }

  private async updateMogiriSetting() {
    this.loading = true;
    AppModule.StartProgress();

    try {
      const settings: MogiriSettingSupplier = JSON.parse(
        JSON.stringify(this.mogiriSetting)
      );
      const colors = settings.issuedTicketBackgroundColors as Record<
        string,
        MogiriSettingSupplierColor
      >;
      this.enableWeeksBgcolor.forEach(color => {
        if (color.enable) {
          colors[color.key] = {
            hex: color.hex,
          };
        } else if (color.preset) {
          colors[color.key] = {
            preset: color.preset as any,
          };
        } else {
          colors[color.key] = null as any;
        }
      });
      if (this.enableExpiredBgColors.enable) {
        colors.expired = {
          hex: this.enableExpiredBgColors.hex,
        };
      } else if (this.enableExpiredBgColors.preset) {
        colors.expired = {
          preset: this.enableExpiredBgColors.preset as any,
        };
      } else {
        colors.expired = null as any;
      }
      if (this.enableColorPrimaryHex.enable) {
        settings.colorPrimaryHex = this.hexa2hex(
          this.enableColorPrimaryHex.hex
        );
      } else {
        settings.colorPrimaryHex = '';
      }
      await putMogiriSetting(settings);

      this.$toast.success(
        this.$t('Succeeded {do}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
        }) as string,
        {
          icon: this.$route.meta.icon,
        }
      );
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
    await this.fetchData();
    AppModule.StopProgress();
    this.loading = false;
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
